"use client";

import { Button } from "@relume_io/relume-ui";
import React from "react";

export function Faq13() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container">
        <div className="rb-12 mb-12 w-full max-w-lg md:mb-18 lg:mb-20">
          <h2 className="rb-5 mb-5 text-5xl font-bold md:mb-6 md:text-7xl lg:text-8xl">
            Questions
          </h2>
          <p className="md:text-md">
            Everything you need to know about connecting your tools.
          </p>
        </div>
        <div className="grid grid-cols-1 gap-10 gap-y-10 md:grid-cols-3 md:gap-x-8 md:gap-y-16 lg:gap-x-12">
          <div>
            <h2 className="mb-3 text-base font-bold md:mb-4 md:text-md">
              Do I need to migrate?
            </h2>
            <p>
              No. IntegrateWise connects to your existing tools without moving
              anything. Your data stays where it is, and we handle the
              complexity in the background.
            </p>
          </div>
          <div>
            <h2 className="mb-3 text-base font-bold md:mb-4 md:text-md">
              Is my data secure?
            </h2>
            <p>
              Yes. The Hub manages all access and routing with enterprise-grade
              security. You can also use Render Only mode for read-only access
              with zero risk to source data.
            </p>
          </div>
          <div>
            <h2 className="mb-3 text-base font-bold md:mb-4 md:text-md">
              Which tools can I connect?
            </h2>
            <p>
              Notion, Coda, Slack, calendars, CRMs, billing tools, and more. If
              you use it for work, IntegrateWise can connect to it.
            </p>
          </div>
          <div>
            <h2 className="mb-3 text-base font-bold md:mb-4 md:text-md">
              Can I use my own AI model?
            </h2>
            <p>
              Yes. Bring Your Own Model (BYOM) lets you use ChatGPT, Claude, or
              any AI you prefer. IntegrateWise works with your choice.
            </p>
          </div>
          <div>
            <h2 className="mb-3 text-base font-bold md:mb-4 md:text-md">
              How long does setup take?
            </h2>
            <p>
              Minutes. Connect once, securely. The AI Loader handles the rest
              with a single click.
            </p>
          </div>
          <div>
            <h2 className="mb-3 text-base font-bold md:mb-4 md:text-md">
              What if I need help?
            </h2>
            <p>
              We're here. Reach out anytime—our team knows this problem inside
              and out.
            </p>
          </div>
        </div>
        <div className="mt-12 md:mt-18 lg:mt-20">
          <h4 className="mb-3 text-2xl font-bold md:mb-4 md:text-3xl md:leading-[1.3] lg:text-4xl">
            Still have questions?
          </h4>
          <p className="md:text-md">Get in touch with our team.</p>
          <div className="mt-6 md:mt-8">
            <Button title="Contact" variant="secondary">
              Contact
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
